import { Routes } from '@angular/router';

import { FormElementsWrapperComponent } from './form-elements-wrapper.component';
import { FormElementsComponent } from './form-elements.component';
import { FormDataResolver } from './form-elements.resolver';

export const formElementsRouting: Routes = [
  {
    path: 'form',
    component: FormElementsWrapperComponent,
    children: [
      {
        path: ':slug',
        component: FormElementsComponent,
        resolve: { data: FormDataResolver },
      },
    ],
  },
];
